export default "__VITE_ASSET__DhNF7Y1a__"